import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginResult } from '../../../models/loginResult.model';
import { AuthService } from '../../../services/auth.service';
import { DialogService } from '../../../services/dialog.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-mynamirialbinding',
  templateUrl: './mynamirialbinding.component.html',
  styleUrls: ['./mynamirialbinding.component.scss']
})
export class MynamirialbindingComponent implements OnInit {
  loginForm: UntypedFormGroup;
  submitted = false;
  oncloseform = false;
  returnUrl: string;  
  displayiFrame=false;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthService,
    private userService: UserService,    
    public dialogRef: MatDialogRef<MynamirialbindingComponent>,    
    ) 
    {
    
    }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],      
    });

  }


  onSubmit(email: string = "", password: string = "") {
    
    if (this.oncloseform) {
      return
    }

    this.submitted = true;         
    this.authenticationService.login(this.f.email.value, this.f.password.value)
    .then((res: LoginResult) => {
      
      this.authenticationService.setCurrentToken(res.Token);
      this.userService.MyNamirialUserBind(this.authenticationService.getCurrentUser().ID, this.authenticationService.getMyNamirialToken())
      .then((bindresult) => {        
        DialogService.Success(this.translate.instant("DIALOGS.OPERATION_COMPLETE"));      
        this.dialogRef.close('loginOK');      
      })
      .catch((err) => {
        this.authenticationService.loggedIn.next(false);
        DialogService.Error(err.message);  
      })      
    }).then(() => {      
    })
    .catch((err) => {
      this.authenticationService.loggedIn.next(false);
      DialogService.Error(err.message);
    });
     
   
  }

  get f() {
    return this.loginForm.controls;
  }
  onAbortClick(): void {    
    this.oncloseform = true;   
    this.dialogRef.close('abort');
  }

  onRegisterClick(): void {
    this.oncloseform = true;
    this.dialogRef.close('Register');
  }
}
